import React from 'react';
import { useSelector } from 'react-redux';

import {
  BLACKLIST_ADD_MODAL_STAGES,
  blacklistedAddMenteeStageSelector,
} from 'features/communicationManagement';
import PersonalisedMenteeEmailersAddConfirmModal from '../PersonalisedMenteeEmailersAddConfirmModal';
import PersonalisedMenteeEmailersAddLearnerModal from '../PersonalisedMenteeEmailersAddLearnerModal';

export default function PersonalisedMenteeEmailersAddModalRenderer() {
  const addModalStage = useSelector(blacklistedAddMenteeStageSelector);

  switch (addModalStage) {
    case BLACKLIST_ADD_MODAL_STAGES.add:
      return <PersonalisedMenteeEmailersAddLearnerModal />;
    case BLACKLIST_ADD_MODAL_STAGES.addConfirmation:
      return <PersonalisedMenteeEmailersAddConfirmModal />;
    default:
      return null;
  }
}
